import * as React from 'react';
import { makeIcon } from './makeIcon';
const ArrowUp = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("polygon", { points: "8.00000021 0 2 6.26026805 3.27292822 7.58841332 7.1513814 3.54172071 7.1513814 16 8.84861903 16 8.84861903 3.54172071 12.7270718 7.58841332 14 6.26026805" })));
export const ArrowUpIcon = makeIcon('arrowUp')(ArrowUp);
//# sourceMappingURL=ArrowUp.js.map